/*@ngInject*/
const BulkResolveRepository = function (baseRepository) {
    angular.extend(this, baseRepository);

    this.resolve = function (params, resolutionNotes) {
        let url = '/rest/SubmissionTask/bulkUpdate',
            config = {
                params: params
            },
            body = {
                status: 1,
                comments: resolutionNotes
            };

        return this.post(url, body, config);
    };
};

angular.module('umLanding')
    .service('bulkResolveRepository', BulkResolveRepository);
